export const formatDate = (date: Date) => {
  return `${prettyNumbers(date.getDate())}-${prettyNumbers(
    date.getMonth() + 1
  )}-${date.getFullYear()} ${prettyNumbers(date.getHours())}:${prettyNumbers(
    date.getMinutes()
  )}`
}

export const prettyNumbers = (number: number): string => {
  if (number < 10) {
    return '0' + number
  }

  return number.toString()
}
